import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@/core/ui';
import { useGetCrossdockLookupQuery, useGetStockLocationsQuery } from '@/warehouse/modules/stocks/business';
import { useLocation, useParams } from 'react-router-dom';
const CrossDockOrLocationChip = () => {
    const { pathname } = useLocation();
    const { crossDockId: crossDockIdUrlParam, locationId: locationIdUrlParam } = useParams();
    const crossDockId = Number(crossDockIdUrlParam);
    const locationId = Number(locationIdUrlParam);
    const { data: crossDocks } = useGetCrossdockLookupQuery();
    // TODO: later. Better to have `useGetStockLocationsLOOKUPQuery` here.
    const { data: locations } = useGetStockLocationsQuery();
    const color = pathname.startsWith('/crossdock/')
        ? 'yellow'
        : pathname.startsWith('/location/')
            ? 'secondary'
            : undefined;
    const label = crossDockId
        ? crossDocks?.find((item) => item.id === crossDockId)?.name
        : locationId
            ? locations?.find((item) => item.id === locationId)?.name
            : undefined;
    return _jsx(Chip, { shape: "rect", label: label, color: color });
};
export { CrossDockOrLocationChip };
